// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__1GU6X","load4":"spinner_load4__2WJwD"};